import FittingStationFinderConstants from '../../constants/fitting_station_finder_constants';
import StationsActions from '../fitting_station_actions';
import { getMap } from '../../helper/gmap';
import { validatePostcode } from '../../../validator/PostcodeAutocompleteValidator';
import LightboxActions from '../lightbox_actions';
import { postcodeInvalidAction } from '../postcode_actions';
import API from '../../../API/api';
import { getValue } from '../../../utilities/local_storage';
import { hideAction as lbUnlockUi } from '../../../_flux/actions/lightbox_ui_lock_actions';
import { CrossSellProductStore } from '../../stores/cross_sell_product_store';

const validatePostcodeForAllStores = (postcode) => {
    return !postcode || !validatePostcode(TYROOLA.globals.store, postcode) || (postcode && (TYROOLA.globals.store !== 'DE' ? postcode.length < 7 : postcode.length !== 5));
}

export const fetchStations = (requestType, data, withoutPrices, multipleProducts = false) => {
    const stationsPromise = $.Deferred();
    let apiPath;
    const { postcode } = data;
    const { voucherData } = TYROOLA.initialFluxStates;
    
    if (validatePostcodeForAllStores(postcode)) {
        LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_USAGE_DESCRIPTION);
        postcodeInvalidAction();
        return;
    }

    let multiFlag = false;
    if (!withoutPrices && (location.pathname.indexOf('/cart/') !== -1 || location.pathname.indexOf('/checkout/') !== -1)) {
        data.qty = 0;
        data.id = 0;
        multiFlag = true;
    }
    const apiData = JSON.parse(JSON.stringify(data));

    if (!window.isCustomSearchClicked) {
        const latLng = getValue('latLng');
        apiData.latitude = latLng?.lat || '-27.4412376';
        apiData.longitude = latLng?.lng || '152.9823835';
    }

    const idVouchers = TYROOLA.initialFluxStates.allDiscounts && TYROOLA.initialFluxStates.allDiscounts.length
        ? TYROOLA.initialFluxStates.allDiscounts.map(d => d.idVoucher)
        : null;
    const hasCrossSellProducts = CrossSellProductStore.getState();
    
    if (data.qty && data.id) {
        apiPath = FittingStationFinderConstants.FITTING_STATIONS_FOR_TYRE_APIPATH;
    } else if (multipleProducts || multiFlag) {
        apiPath = FittingStationFinderConstants.FITTING_STATIONS_FOR_POSTCODE_APIPATH;
    } else {
        apiPath = FittingStationFinderConstants.FITTING_STATIONS_WITH_FROM_PRICE_APIPATH;
    }

    if (withoutPrices) {
        apiData.checkPrice = 0;
    }

    if (typeof apiData.qty !== 'undefined' && !apiData.qty) {
        delete apiData.qty;
    }
    if (typeof apiData.id !== 'undefined' && !apiData.id) {
        delete apiData.id;
    }
    if (hasCrossSellProducts.length) {
        apiData.crossSellProducts = hasCrossSellProducts.filter(csp => csp.preselected).map(csp => ({ spinachId: (csp.spinachId || csp.id), cartQty: (csp.syncQty ? (apiData.qty * 1) : 1) }));
    }
    apiData.idVouchers = [];
    if (idVouchers) {
        apiData.idVouchers = idVouchers;

        if (voucherData) {
            apiData.idVouchers = voucherData && voucherData.allDiscounts
                ? [...apiData.idVouchers, voucherData.allDiscounts.map((d) => d.idVoucher)]
                : [];
        }
    } else if (voucherData) {
        apiData.idVouchers = voucherData && voucherData.allDiscounts
            ? voucherData.allDiscounts.map((d) => d.idVoucher)
            : [];
    }
    apiData.radiusKm = apiData.radiusKm || 21.5;

    if (hasCrossSellProducts.length || idVouchers) {
        StationsActions[requestType] = API.POST({
            apiPath,
            data: JSON.stringify(apiData),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
        });
    } else {
        StationsActions[requestType] = API.GET({
            apiPath,
            data: apiData,
            dataType: 'json',
        });
    }

    StationsActions[requestType].then((stations, message, res) => {
        const map = getMap();
        if (res.status === 200) {
            stations.forEach((station) => {
                const realDistance = map.calculateDistance({
                    latitude: data.latitude,
                    longitude: data.longitude,
                }, station);
                const distance = station.isMobileFitter ? 0 : realDistance;

                station.distance = distance;
                station.sort.distance = station.totalPrice.match(/Free fitting/) ? distance / 1000 : distance;

                if (station.sponsored) {
                    station.sort.distance = -1;
                }
            });

            if (!withoutPrices) {
                setTimeout(() => {
                    stationsPromise.resolve(stations);
                }, 100);
            } else {
                stationsPromise.resolve(stations);
            }
        } else {
            LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_USAGE_DESCRIPTION);
            stationsPromise.reject();
        }
        lbUnlockUi();
    }).catch((e) => {
        if (e.statusText !== 'abort') {
            LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_USAGE_DESCRIPTION);
            stationsPromise.reject();
        }
    });

    return stationsPromise;
};
